import { CONFIG } from "./config";
import { type RngState, nextRandom } from "./rng";

export interface WeatherDay {
  name: string;
  outputMultiplierByType: Record<string, number>;
}

export function rollWeather(rng: RngState): WeatherDay {
  const conditions = CONFIG.weatherConditions;
  const totalWeight = conditions.reduce((sum, c) => sum + c.weight, 0);
  let roll = nextRandom(rng) * totalWeight;
  for (const c of conditions) {
    if (roll < c.weight) {
      return { name: c.name, outputMultiplierByType: c.outputMultiplierByType };
    }
    roll -= c.weight;
  }
  const last = conditions[conditions.length - 1];
  return { name: last.name, outputMultiplierByType: last.outputMultiplierByType };
}
